import React from 'react';
import { FileDown } from 'lucide-react';

interface ReportDownloadButtonProps {
  url: string;
}

export default function ReportDownloadButton({ url }: ReportDownloadButtonProps) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-700 transition-colors"
    >
      <FileDown className="w-4 h-4 mr-2" />
      Download Report
    </a>
  );
}